import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import axios from "axios/index";

import Header from '../../../Header/index';
import urls from "../../../../utils/urls";
import {ajaxHandler} from "../../../../utils/errors";
import {tokenHeader} from "../../../../utils/headers";
import PageNotFound from '../../../../components/PageNotFound/pageNotFound';
import { Spinner } from '../../../../components/Loading/Spinner';
import { reloadedTrip } from '../../../../actions/trip_actions';
import helpers from '../../../../utils/helpers';

import TripSteps from './TripSteps';
import TripAudit from './TripAudit';
import TripDispatch from './TripDispatch';
import TripWaitingScale from './TripWaitingScale';
import TripDocControl from './TripDocControl';
import TripDischarge from './Discharge/index';
import TripMetadata from './TripMetadata';
import TripClosed from './Done/';
import TripRejectModal from './TripRejectModal';
import TripCancelModal from './TripCancelModal';
import TripProgrammingFormEdit from './TripProgrammingForm';
import TripDispatchFormEdit from './TripDispatchForm';
import TripProviderFormEdit from './TripProviderForm'

import TripProgrammingFormDone from './Done/TripProgrammingForm';
import TripProviderFormDone from './Done/TripProviderForm';
import TripDispatchDone from './Done/TripDispatch';
import TripPEntryDone from './Done/TripPlantEntry';
import TripDocControlDone from './Done/TripDocControl';
import TripDischargeDone from './Done/TripDischarge';


class Trip extends Component {

    constructor(props) {
        super(props);

        const {fetchedTrip} = this.props;

        this.state = {
            trip: fetchedTrip,
            tripId: fetchedTrip.id,
            ajaxInProgress: false,
            activeStep: null
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.trip && nextProps.trip.trip_updated){
            this.setState({trip: false}, this._fetchTrip);
        }
    }

    _fetchTrip = () => {
        // To reload trip
        if(this.state.trip){this.setState({trip: false});};

        let {tripId} = this.state;
        if(!tripId || isNaN(tripId)){return false;}

        let TRIP_URL = `${urls.API_ROOT}/api/v1/trip/id/${this.state.tripId}/`;
        axios
            .get(TRIP_URL, tokenHeader())
            .then(response => {
                this.setState({trip: response.data, activeStep: null}, this.props.reloadedTrip);
            })
            .catch(error => {
                try{
                    let response = error.response;
                    if(response.status === 404){
                        // To redirect user to 404 page, set a non-existant id
                        this.setState({tripId: 'idNotFound'})
                    }else{
                        ajaxHandler(error);
                    }
                }
                catch (e){
                    ajaxHandler(error);
                }
            });
    };

    _changeStep = (step) => {
        this.setState({activeStep: step.code})
    };

    render() {
        let {trip, tripId, activeStep} = this.state;

        // Security check
        if(!this.props.user || !tripId || isNaN(tripId)){
            return <PageNotFound />;
        }

        // User data
        let isProvider = helpers.isUserProvider(this.props.user);
        let isReception = helpers.isUserReception(this.props.user);

        // Waiting for options
        if(!trip){
            return (
                <div className={"main-dashboard"}>
                    <Header active={"new-trip"} />
                    <div className={"valign-wrapper w100"} style={{height: '100%', minHeight: '300px'}}>
                        <Spinner />
                    </div>
                </div>
            );
        }

        // Trip data
        let status = trip.status.id;

        // Trips steps
        let currentStep = 0;
        let steps = [];

        // Trip logic for render
        let body = <div>Case not ready:<br />Status: {status}</div>;
        let showMetadata = true;
        let showRejectionButton = false;
        let showCancellationButton = false;
        let activeTrip = true;

        if(trip.incoterm && trip.incoterm.name.toUpperCase() === 'FOB'){
            steps = helpers.tripSteps.FOB;
            switch(status){
                case 'A0':
                    body = <TripDispatch trip={trip} />;
                    currentStep = 1;
                    if(isProvider || isReception){showMetadata = false;}
                    break;
                case 'B0':
                    body = <TripWaitingScale message={"Esperando datos de la balanza"} title={"Ingreso a Terminal"} />;
                    currentStep = 2;
                    break;
                case 'B4':
                    body = <TripWaitingScale message={"Esperando camión en terminal"} title={"Ingreso a Terminal"} />;
                    currentStep = 2;
                    break;
                case 'C0':
                    if(!trip.discharge_documentation_control_check){
                        body = <TripDocControl trip={trip} reloadTrip={this._fetchTrip} />;
                        currentStep = 3;
                    }else{
                        body = <TripDischarge trip={trip} reloadTrip={this._fetchTrip}/>;
                        currentStep = 4;
                    }
                    break;
                case 'C4':
                    body = <TripDischarge trip={trip} />;
                    currentStep = 4;
                    break;
                case 'D0':
                    body = <TripWaitingScale message={"Esperando datos de la balanza"} title={"Balanza de Salida"}  />;
                    currentStep = 5;
                    break;
                case 'E3':
                    body = <TripWaitingScale message={"Validaciones de salida con errores - Esperando resolución de conflicto por parte del operador de ventanilla de salida"}  title={"Balanza de Salida"} />;
                    currentStep = 5;
                    break;
                case 'D5':
                case 'E5':
                case 'E103':
                case 'E104':
                    body = <TripClosed trip={trip} />;
                    currentStep = 7;
                    showMetadata = false;
                    activeTrip = false;
                    break;
                default:
                    break;
            }
        }else{
            steps = helpers.tripSteps.CIF;
            switch(status){
                case 'B0':
                    body = <TripWaitingScale message={"Esperando datos de la balanza"} title={"Ingreso a Terminal"} />;
                    currentStep = 1;
                    break;
                case 'B4':
                    body = <TripWaitingScale message={"Esperando camión en terminal"} title={"Ingreso a Terminal"} />;
                    currentStep = 1;
                    break;
                case 'C0':
                    if(!trip.discharge_documentation_control_check) {
                        body = <TripDocControl trip={trip} reloadTrip={this._fetchTrip} />;
                        currentStep = 2;
                    }else{
                        body = <TripDischarge trip={trip} reloadTrip={this._fetchTrip} />;
                        currentStep = 3;
                    }
                    break;
                case 'C4':
                    body = <TripDischarge trip={trip} />;
                    currentStep = 3;
                    break;
                case 'D0':
                    body = <TripWaitingScale message={"Esperando datos de la balanza"} title={"Balanza de Salida"}  />;
                    currentStep = 4;
                    break;
                case 'E3':
                    body = <TripWaitingScale message={"Validaciones de salida con errores - Esperando resolución de conflicto por parte del operador de ventanilla de salida"} title={"Balanza de Salida"}  />;
                    currentStep = 4;
                    break;
                case 'D5':
                case 'E5':
                case 'E103':
                case 'E104':
                    body = <TripClosed trip={trip} />;
                    currentStep = 6;
                    showMetadata = false;
                    activeTrip = false;
                    break;
                default:
                    break;
            }
        }

        // If user changed active Step, render done body
        if(activeStep){
            if(trip.incoterm && trip.incoterm.name === 'FOB'){
                switch(activeStep){
                    case 'initial':
                        body = <TripProgrammingFormDone trip={trip} boxed={true} />;
                        showMetadata = false;

                        if(helpers.canEditOpenTrip(this.props.user) && ['A0', 'B0'].includes(status)){
                            body = <TripProgrammingFormEdit trip={trip} next_status={status} reloadTrip={this._fetchTrip} />;
                        }

                        break;
                    case 'dispatch':
                        if(status !== 'A0'){
                            body = <TripDispatchDone trip={trip} boxed={true} />;

                            if(helpers.canEditOpenTripOriginData(this.props.user) && status === 'B0'){
                                body = <TripDispatchFormEdit trip={trip} next_status={status} reloadTrip={this._fetchTrip} />;
                            }
                        }
                        break;
                    case 'entry':
                        if(status !== 'B0')
                            body = <TripPEntryDone trip={trip} boxed={true} />;
                        break;
                    case 'documentation':
                        if(trip.discharge_documentation_control_check)
                            body = <TripDocControlDone trip={trip} boxed={true} />;
                        break;
                    case 'discharge':
                        if(status !== 'C0')
                            body = <TripDischargeDone trip={trip} boxed={true} />;
                        break;
                    case 'exit':
                        // Last step. Nothing to do
                        break;
                    case 'done':
                        // Last step. Nothing to do
                        break;
                    default:
                        break;
                }
            }else{
                switch(activeStep){
                    case 'initial':
                        body = <TripProviderFormDone trip={trip} boxed={true} />;
                        showMetadata = false;

                        if(helpers.canEditOpenTripOriginData(this.props.user) && status === 'B0'){
                            body = <TripProviderFormEdit trip={trip} next_status={status} reloadTrip={this._fetchTrip} />
                        }
                        break;
                    case 'entry':
                        if(status !== 'B0')
                            body = <TripPEntryDone trip={trip} boxed={true} />;
                        break;
                    case 'documentation':
                        if(trip.discharge_documentation_control_check)
                            body = <TripDocControlDone trip={trip} boxed={true} />;
                        break;
                    case 'discharge':
                        if(status !== 'C0')
                            body = <TripDischargeDone trip={trip} boxed={true} />;
                        break;
                    case 'exit':
                        // Last step. Nothing to do
                        break;
                    case 'done':
                        // Last step. Nothing to do
                        break;
                    default:
                        break;
                }
            }
        }

        // Terminals without discharge process go directly to D5
        let closedShortTrip = !trip.terminal.discharge_process && status === 'D5';
        if(closedShortTrip){
            if(trip.incoterm && trip.incoterm.name.toUpperCase() === 'FOB'){
                steps = [steps[0], steps[1]];
            }else{
                steps = [steps[0],];
            }
        }

        // Steps configuration
        let showSteps = (helpers.states.canceled.indexOf(status) === -1 && helpers.states.rejected.indexOf(status) === -1);
        let actionableSteps = !isProvider && !closedShortTrip;

        // Limit vision to Providers && Terminals without discharge process
        if((isProvider && ['A0', 'B0'].indexOf(status) === -1) || closedShortTrip){
            showMetadata = false;
            body = <TripClosed trip={trip} />;
        }

        // Enables provider to action steps in A0 & B0 steps
        if(isProvider && ['A0', 'B0'].includes(status)) {
            actionableSteps = true;
        }

        // Buttons
        if(helpers.canUserReject(this.props.user) && status === 'C0'){
            showRejectionButton = trip.discharge.length === 0;
        }

        if(helpers.canUserCancel(this.props.user) && ['A0', 'B0'].indexOf(status) > -1){
            showCancellationButton = true;
        }


        return (
            <div>
                <div className={"main-dashboard"} style={{paddingBottom: '100px'}}>
                    <Header active={helpers.trip_type.FE} />
                    {showSteps ?
                    <TripSteps steps={steps} currentStep={currentStep}
                               changeAction={actionableSteps ? this._changeStep : null}
                               activeStep={this.state.activeStep}
                               activeTrip={activeTrip} />
                        :
                        <div className="row margin-top-20">&nbsp;</div>
                    }
                    {helpers.isUserAdmin(this.props.user) &&
                        <TripAudit trip={trip} user={this.props.user} />
                    }
                    {body}
                    {showCancellationButton && <TripCancelModal trip={trip} reloadTrip={this._fetchTrip} />}
                    {showRejectionButton && <TripRejectModal trip={trip} reloadTrip={this._fetchTrip} />}
                </div>
                {showMetadata && <TripMetadata trip={trip} />}
            </div>
        );
    }
}


const
    mapStateToProps = (state) => {
        return {
            user: state.user,
            trip: state.trip
        }
    };

const
    mapDispatchToProps = (dispatch) => {
        return bindActionCreators({reloadedTrip}, dispatch);
    };

export default connect(mapStateToProps, mapDispatchToProps)(Trip);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/index.js